var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal-comp"},[_c('div',{staticClass:"modal",style:({'width': '800px', 'height' : '650px'})},[_c('section',{staticClass:"modal-card-body"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("lbl_payment_in_progress"))+"...")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }